/**
 * Model for the summation of miner emissions and fees.
 */
export default class MoneroMinerTxSum {
    constructor(txSum) {
        Object.assign(this, txSum);
        // deserialize bigints
        if (this.emissionSum !== undefined && typeof this.emissionSum !== "bigint")
            this.emissionSum = BigInt(this.emissionSum);
        if (this.feeSum !== undefined && typeof this.feeSum !== "bigint")
            this.feeSum = BigInt(this.feeSum);
    }
    toJson() {
        let json = Object.assign({}, this);
        if (this.getEmissionSum() !== undefined)
            json.emissionSum = this.getEmissionSum().toString();
        if (this.getFeeSum() !== undefined)
            json.feeSum = this.getFeeSum().toString();
        return json;
    }
    getEmissionSum() {
        return this.emissionSum;
    }
    setEmissionSum(emissionSum) {
        this.emissionSum = emissionSum;
        return this;
    }
    getFeeSum() {
        return this.feeSum;
    }
    setFeeSum(feeSum) {
        this.feeSum = feeSum;
        return this;
    }
}
